import React from "react";
import Toeic from "./Toeic.js";

const ToeicPage = () => {
  return (
    <div  class="mx-auto">
      <div style={{ marginTop: "80px"}}>
        <h1 className="text-center" >TOEIC Style Exam</h1>
      </div>
      <Toeic />
    </div>
  );
};

export default ToeicPage;
